export default __webpack_public_path__ + "static/sdk-text-898e7307d307445134bd75a7e191cc3c.gif";